import React from "react";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl} from "../../../_helpers";
import {Link} from "react-router-dom";

export const ModulesDropdown = () => {
    return (
        <div className="od_modules">
            <div className="row justify-content-md-center">
                <div className="col mb-10">
                    <Link to="/overview"
                          className="btn btn-block btn-light btn-hover-primary text-dark-50 text-center py-5 px-2 waves-effect waves-light">
							<span className="svg-icon svg-icon-3x svg-icon-primary m-0">
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Box2.svg")}/>
							</span>
                        <span className="module-name d-block font-weight-bold mt-2">Overview</span>
                    </Link>
                </div>
                <div className="col mb-10">
                    <Link to="/opteemum"
                          className="btn btn-block btn-light btn-hover-primary text-dark-50 text-center py-5 px-2 waves-effect waves-light">
							<span className="svg-icon svg-icon-3x svg-icon-primary m-0">
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Box2.svg")}/>
							</span>
                        <span className="module-name d-block font-weight-bold mt-2">Opteemum</span>
                    </Link>
                </div>
                <div className="col mb-10">
                    <Link to="/inventoree"
                          className="btn btn-block btn-light btn-hover-primary text-dark-50 text-center py-5 px-2 waves-effect waves-light">
							<span className="svg-icon svg-icon-3x svg-icon-primary m-0">
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Box2.svg")}/>
							</span>
                        <span className="module-name d-block font-weight-bold mt-2">Inventoree</span>
                    </Link>
                </div>
                <div className="col mb-10">
                    <Link to="/proactivitee"
                          className="btn btn-block btn-light btn-hover-primary text-dark-50 text-center py-5 px-2 waves-effect waves-light">
							<span className="svg-icon svg-icon-3x svg-icon-primary m-0">
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Box2.svg")}/>
							</span>
                        <span className="module-name d-block font-weight-bold mt-2">Proactivitee</span>
                    </Link>
                </div>
                <div className="col mb-10">
                    <Link to="/softsee"
                          className="btn btn-block btn-light btn-hover-primary text-dark-50 text-center py-5 px-2 waves-effect waves-light">
							<span className="svg-icon svg-icon-3x svg-icon-primary m-0">
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Box2.svg")}/>
							</span>
                        <span className="module-name d-block font-weight-bold mt-2">Softsee</span>
                    </Link>
                </div>
                <div className="col mb-10">
                    <Link to="/easeedesk/tickets"
                          className="btn btn-block btn-light btn-hover-primary text-dark-50 text-center py-5 px-2 waves-effect waves-light">
							<span className="svg-icon svg-icon-3x svg-icon-primary m-0">
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Box2.svg")}/>
							</span>
                        <span className="module-name d-block font-weight-bold mt-2">Easeedesk</span>
                    </Link>
                </div>
                <div className="col mb-10">
                    <Link to="/easeetask/projects"
                          className="btn btn-block btn-light btn-hover-primary text-dark-50 text-center py-5 px-2 waves-effect waves-light">
							<span className="svg-icon svg-icon-3x svg-icon-primary m-0">
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Box2.svg")}/>
							</span>
                        <span className="module-name d-block font-weight-bold mt-2">Easeetask</span>
                    </Link>
                </div>
                <div className="col mb-10">
                    <Link to="/protectee"
                          className="btn btn-block btn-light btn-hover-primary text-dark-50 text-center py-5 px-2 waves-effect waves-light">
							<span className="svg-icon svg-icon-3x svg-icon-primary m-0">
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Box2.svg")}/>
							</span>
                        <span className="module-name d-block font-weight-bold mt-2">Protectee</span>
                    </Link>
                </div>
                <div className="col mb-10">
                    <Link to="/printeeng"
                          className="btn btn-block btn-light btn-hover-primary text-dark-50 text-center py-5 px-2 waves-effect waves-light">
							<span className="svg-icon svg-icon-3x svg-icon-primary m-0">
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Box2.svg")}/>
							</span>
                        <span className="module-name d-block font-weight-bold mt-2">Printeeeng</span>
                    </Link>
                </div>
                <div className="col mb-10">
                    <Link to="/securitee"
                          className="btn btn-block btn-light btn-hover-primary text-dark-50 text-center py-5 px-2 waves-effect waves-light">
							<span className="svg-icon svg-icon-3x svg-icon-primary m-0">
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Box2.svg")}/>
							</span>
                        <span className="module-name d-block font-weight-bold mt-2">Securitee</span>
                    </Link>
                </div>
                <div className="col mb-10">
                    <Link to="/productivitee"
                          className="btn btn-block btn-light btn-hover-primary text-dark-50 text-center py-5 px-2 waves-effect waves-light">
							<span className="svg-icon svg-icon-3x svg-icon-primary m-0">
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Box2.svg")}/>
							</span>
                        <span className="module-name d-block font-weight-bold mt-2">Productivitee</span>
                    </Link>
                </div>
                <div className="col mb-10">
                    <Link to="/saveenergee"
                          className="btn btn-block btn-light btn-hover-primary text-dark-50 text-center py-5 px-2 waves-effect waves-light">
							<span className="svg-icon svg-icon-3x svg-icon-primary m-0">
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Box2.svg")}/>
							</span>
                        <span className="module-name d-block font-weight-bold mt-2">Saveenergee</span>
                    </Link>
                </div>
            </div>
        </div>
    );
}
